<template>
    <footer class="footer">
        <!-- DESKTOP -->
        <div  v-if="$mq !== 'mobile'"  class="container">
			<span class="pull-right">
				<small v-if='env != "production" '>{{ env.substring(0,1).toUpperCase() }}&nbsp;&nbsp;</small>
				<b>&copy;2023 FiledSafely.com</b>
			</span>
			<span class="pull-left">
				<router-link                              to="/privacy">Privacy</router-link>&nbsp;&middot;&nbsp;
				<router-link                              to="/terms"  >Terms of use</router-link>&nbsp;&middot;&nbsp;
				<router-link v-if='env != "production" ' to="/contact">Contact</router-link>&nbsp;&middot;&nbsp;
				<router-link v-if='env != "production" ' to="/about"  >About</router-link>
			</span>
        </div>

        <!-- MOBILE -->
        <div  v-if="$mq === 'mobile'"  class="container">
			<small class="pull-right">
				<span v-if='env != "production" '>{{ env.substring(0,1).toUpperCase() }}&nbsp;&nbsp;</span>
				<b>&copy;2023</b>&nbsp;&nbsp;
			</small>
			<small class="pull-left">
				<router-link                              to="/privacy">Privacy</router-link>&nbsp;&middot;&nbsp;
				<router-link                              to="/terms"  >Terms of use</router-link>&nbsp;&middot;&nbsp;
				<router-link v-if='env != "production" ' to="/contact">Contact</router-link>&nbsp;&middot;&nbsp;
				<router-link v-if='env != "production" ' to="/about"  >About</router-link><br>
			</small>
        </div>
        <cookie-law v-on:accept="storeCookie()" v-show="cookieAccepted == false" theme="base"></cookie-law>
    </footer>
</template>

<script>
    import CookieLaw from "vue-cookie-law";

    export default {
        components: {
            CookieLaw
        },

        data() {
            return {
                env: process.env.VUE_APP_ENV,
            };
        },
        computed: {
			cookieAccepted() {
				return this.$store.getters.COOKIE_LAW;
		    }
        },

        methods: {
			storeCookie() {
				this.$store.commit("COOKIE_LAW");
			}
        },

        mounted() {
            //console.log("env=", process.env.VUE_APP_ENV);
        }
    };
</script>
